export enum PillIds {
  CONSENTED = 'consented',
  INTERESTED = 'interested',
  STATUS = 'status',
  RATE_CONSENTED = 'rate_consented',
  RATE_INTERESTED = 'rate_interested',
}

export enum CampaignsPillId {
  ACTIVE_CAMPAIGNS = 'active_campaigns',
  INACTIVE_CAMPAIGNS = 'inactive_campaigns',
}

export interface Pill {
  id: string;
  label: string;
}
